
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/karticky",
      function () {
        return require("private-next-pages/karticky.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/karticky"])
      });
    }
  